import React from 'react';
import PropTypes from 'prop-types';

import { Text, Header, Avatar, CopyIcon, ContainedButton } from '../index';

import {
    StyledCard,
    StyledContractContainer,
    StyledAvatarContainer,
    StyledContractContent,
    StyledTextContainer,
} from './style';

export const ContactCard = ({ data, mdUp, onGoBack }) => {
    return (
        <div>
            {!mdUp && (
                <Header
                    onClickGoBack={onGoBack}
                    showGoBack1
                    childrenContainerStyle={{ textAlign: 'center' }}
                >
                    <Text $bold $fontSize="18px">
                        Contact us
                    </Text>
                </Header>
            )}
            <StyledCard variant="outlined" padding="20px">
                <Text $bold $fontSize="18px" style={{ marginBottom: '10px' }}>
                    Contact
                </Text>
                <StyledContractContainer mdUp={mdUp}>
                    <StyledAvatarContainer>
                        <Avatar
                            src={data.avatar?.url}
                            alt={data.name}
                            $avatarSize={mdUp ? '62px' : '80px'}
                            $borderRadius="50%"
                        />
                    </StyledAvatarContainer>
                    <StyledContractContent>
                        <StyledTextContainer mdUp={mdUp}>
                            <Text
                                $fontSize="18px"
                                $medium
                                style={{
                                    margin: '20px 0 10px',
                                    textAlign: mdUp ? 'left' : 'center',
                                }}
                            >
                                {data?.name}
                            </Text>
                        </StyledTextContainer>

                        <StyledTextContainer mdUp={mdUp}>
                            <Text $fontSize="12px" $color="gray2">
                                Counseling Service ID
                            </Text>
                            <Text>{data?.hospitalID}</Text>
                        </StyledTextContainer>
                        <StyledTextContainer mdUp={mdUp}>
                            <Text $fontSize="12px" $color="gray2">
                                Contact mail
                            </Text>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Text>{data?.email}</Text>
                                <CopyButton value={data.email} />
                            </div>
                        </StyledTextContainer>
                        <StyledTextContainer mdUp={mdUp}>
                            <Text $fontSize="12px" $color="gray2">
                                Contact number
                            </Text>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Text>{data?.phoneNumber}</Text>
                                <CopyButton value={data.phoneNumber} />
                            </div>
                        </StyledTextContainer>
                        <StyledTextContainer mdUp={mdUp}>
                            <Text $fontSize="12px" $color="gray2">
                                Address
                            </Text>
                            <Text>{data?.address}</Text>
                        </StyledTextContainer>
                    </StyledContractContent>
                </StyledContractContainer>
            </StyledCard>
        </div>
    );
};

ContactCard.propTypes = {
    data: PropTypes.object,
    mdUp: PropTypes.bool,
    onGoBack: PropTypes.func,
};

const CopyButton = ({ value }) => {
    return (
        <ContainedButton
            $backgroundColor="gray5"
            onClick={() => navigator.clipboard.writeText(value)}
            disabled={!value}
            style={{
                borderRadius: '6px',
                width: 'auto',
                height: '28px',
                padding: '5px 12px',
                boxShadow: 'none',
            }}
        >
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', columnGap: '8px' }}>
                <CopyIcon />
                <Text $fontSize="12px" $color="gray2">
                    Copy
                </Text>
            </div>
        </ContainedButton>
    );
};

CopyButton.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
